import { useCallback, useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";

export default function DateField({ value, onCommit, testId }) {
  const [raw, setRaw] = useState(value || "");
  const [check, setCheck] = useState(null);

  useEffect(() => {
    setRaw(value || "");
  }, [value]);

  const commit = useCallback(async () => {
    if (!raw) {
      onCommit("");
      setCheck(null);
      return;
    }
    try {
      const { data } = await api.post("/validate-date", { raw });
      setCheck(data);
      if (data.is_valid && !data.ambiguous && data.iso) {
        onCommit(data.iso);
        setRaw(data.iso);
      }
    } catch (err) {
      console.warn("Date validation request failed:", err?.message || err);
    }
  }, [raw, onCommit]);

  const pick = (iso, label) => {
    onCommit(iso);
    setRaw(iso);
    setCheck({
      is_valid: true,
      ambiguous: false,
      iso,
      issues: [],
      suggestions: [],
      resolvedLabel: label,
    });
  };

  return (
    <div>
      <input
        data-testid={testId}
        className="field-input"
        placeholder="YYYY-MM-DD"
        value={raw}
        onChange={(e) => setRaw(e.target.value)}
        onBlur={commit}
      />
      {check?.ambiguous && (
        <div
          className="mt-2 p-3 rounded-md text-xs flex gap-2 items-start"
          style={{
            background: "var(--warn-bg)",
            border: "1px solid var(--warn-border)",
            color: "var(--warn-text)",
          }}
          data-testid="date-ambiguous"
        >
          <AlertTriangle className="w-4 h-4 mt-0.5" />
          <div>
            <div className="font-semibold mb-1.5">{check.issues[0]}</div>
            <div className="flex gap-2 flex-wrap">
              {check.suggestions.map((s) => (
                <button
                  key={s.iso}
                  data-testid={`date-suggestion-${s.iso}`}
                  onClick={() => pick(s.iso, s.label)}
                  className="px-2 py-1 rounded-md text-xs font-medium bg-white hover:bg-white/70 transition-colors"
                  style={{ border: "1px solid var(--warn-border)", color: "var(--warn-text)" }}
                >
                  {s.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      {check?.is_valid === false && !check.ambiguous && (
        <div className="mt-1 text-xs" style={{ color: "#B45309" }}>
          {check.issues?.[0]}
        </div>
      )}
    </div>
  );
}
